import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class ServicesMenuHarmonyIcon extends BaseIcon {
  getChildren = () => [
    <path
        d="M30 4.9c-2.4 2.9-13.4 17-13.4 32.5 0 17.3 12.1 17.8 13.4 17.8 3.1 0 13.4-1.3 13.4-17.8 0-15.5-11-29.6-13.4-32.5z"
        fill="#8c00ff"/>,
    <path fill="#7d0085"
          d="M38.8 18.8c-5.2 2.1-9.9 5.1-13.9 9-12.1 12.1-5.9 21.1-3.6 23.7 2.3 2.2 5.4 3.5 8.7 3.6 3.1 0 13.4-1.3 13.4-17.8-.1-6.4-1.7-12.8-4.6-18.5z"/>,
    <path fill="#7d0085"
          d="M38.2 52c1.8-1.8 9.9-11.2-3.1-24.2-4-3.9-8.8-6.9-13.9-9-2.9 5.8-4.4 12.1-4.6 18.5 0 17.3 12.1 17.8 13.4 17.8 2.3 0 4.6-.6 6.6-1.8.6-.4 1.1-.8 1.6-1.3z"/>,
    <path fill="#e45785"
          d="M59.1 13.8c-6 .5-11.9 1.8-17.5 3.9 2.7 5.7 4.8 12.5 4.8 19.6S44.7 49 42.3 52.1c1.3-1 2.5-2 3.6-3.2 12.4-12.4 13.9-33.3 14-34.1.1-.5-.3-1-.8-1z"/>,
    <path
        d="M30.6 55.1h.7c1.9-.2 3.7-.8 5.3-1.7.6-.4 1.1-.9 1.6-1.4 1.8-1.8 9.9-11.2-3.1-24.2-1.6-1.6-3.3-3-5.1-4.2-1.8 1.3-3.5 2.7-5.1 4.2-12.1 12.1-5.9 21.1-3.6 23.7 2 2 4.7 3.2 7.5 3.5h.7l1.1.1z"
        fill="#700046"/>,
    <path fill="#e45785"
          d="M13.5 37.3c.2-6.8 1.8-13.5 4.8-19.6-5.6-2-11.5-3.3-17.4-3.9-.5 0-.9.4-.9.9.1.9 1.5 21.7 14 34.1 1.2 1.2 2.5 2.4 3.9 3.4-2.5-3-4.4-7.7-4.4-14.9z"/>
  ]
  getViewBox = () => '0 0 60 60'
}
